import { jsx as _jsx } from "react/jsx-runtime";
import cx from 'clsx';
import * as styles from './toggler.module.scss';
export const Toggler = ({ checked: toggler, disabled = false, noCheck = false, theme = 'serp', onClick, }) => {
    const handleClick = (e) => {
        e.stopPropagation();
        onClick();
    };
    return (_jsx("div", { className: cx(styles.toggler, disabled && styles.toggler_disabled, toggler && styles.toggler_active, styles[theme]), onClick: handleClick, children: _jsx("span", { className: cx(styles.circle, !noCheck && 'kw kw-check') }) }));
};
